import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequiredElementComponent } from './required-element.component';



@NgModule({
  declarations: [
    RequiredElementComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    RequiredElementComponent
  ],
})
export class RequiredElementModule { }
